export const GROUPED_COMBOBOX_ITEM_HEIGHT = 32;
